import { render, staticRenderFns } from "./helloteca_ok.vue?vue&type=template&id=dc966998&scoped=true"
import script from "./helloteca_ok.vue?vue&type=script&lang=js"
export * from "./helloteca_ok.vue?vue&type=script&lang=js"
import style0 from "./helloteca_ok.vue?vue&type=style&index=0&id=dc966998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc966998",
  null
  
)

export default component.exports